/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Billing_Renews_OnInputs */

const en_settings_billing_renews_on = /** @type {(inputs: Settings_Billing_Renews_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Renews on ${i?.date}`)
};

const zh_settings_billing_renews_on = /** @type {(inputs: Settings_Billing_Renews_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} 续订`)
};

/**
* | output |
* | --- |
* | "Renews on {date}" |
*
* @param {Settings_Billing_Renews_OnInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_renews_on = /** @type {((inputs: Settings_Billing_Renews_OnInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Renews_OnInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_renews_on(inputs)
	return zh_settings_billing_renews_on(inputs)
});
export { settings_billing_renews_on as "settings.billing.renews_on" }